var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6.35 6.348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M148 20h24v24h-24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 -39.158 -5.292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.177 28.068q.113-.603.113-1.216a6.857 6.857 0 0 0-13.304-2.329 3.43 3.43 0 0 0-4.603 2.386 5.144 5.144 0 0 0 .763 10.23h6.858v-8.572a.857.857 0 0 1 1.714 0v8.572h5.144a5.143 5.143 0 0 0 3.315-9.071M165.734 38.247a.857.857 0 0 0-1.191 0l-2.825 2.823v-3.931h-1.714v3.93l-2.823-2.822a.857.857 0 0 0-1.212 1.212l4.286 4.286a.857.857 0 0 0 1.214 0l4.286-4.286a.857.857 0 0 0-.021-1.212"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.4205214baf8ebc24d58cd003590b667b.svg";
export { ForwardRef as ReactComponent };